const card = post => {
  return `
  <div class="col-xs-12 col-md-6 col-3 n__calendar__item__col">
  <article class="n__calendar__card">
    <div class="n__calendar__card__top">
      <a class="n__calendar__card__thumb" style="background-image: url(${post.img});" aria-label="${post.post_title}" href="${post.url}"></a>
    </div>
    <h3 class="n__calendar__card__heading"><a href="${post.url}">${post.post_title}</a></h3>
    <time class="n__calendar__card__date">${post.nuo}</time>
    ${
      post.vieta ? '<div class="n__calendar__card__place">'+post.vieta+'</div>' : ''
    }
    ${
      post.excerpt ? '<p class="n__calendar__card__excerpt">'+post.excerpt+'</p>' : ''
    }
    <div class="n__calendar__card__buttons">
      <a href="${post.url}">${post.more_text}</a>
      ${post.button_text && post.button_url ? '<a href="'+post.button_url+'">'+post.button_text+'</a>' : ''}
    </div>
  </article>
  </div>
  `;
};

export const formatHTML = posts => {
  let html = '';
  posts.forEach(post => {
    html += card(post);
  });
  return html; 
};